import React from "react"
import styled from "styled-components"
import { space, color } from "styled-system"

const View = styled(({ space, color, ...props }) => <div {...props} />)`
  ${space};
  ${color};
  ${props => (props.maxWidth ? props.theme.maxWidth : null)};
  ${({ center }) =>
    center === true &&
    `
    margin-left: auto;
    margin-right: auto;
  `};
`

export default View
